'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleBox = function (_React$Component) {
    _inherits(ToggleBox, _React$Component);

    function ToggleBox(props) {
        _classCallCheck(this, ToggleBox);

        var _this = _possibleConstructorReturn(this, (ToggleBox.__proto__ || Object.getPrototypeOf(ToggleBox)).call(this, props));

        _this.toggleBoxRef = _react2.default.createRef();
        _this.isTogglingTimer = undefined;

        _this.state = {
            isToggling: false,
            hideChildren: props.collapsed,
            allowOverflow: !props.collapsed,
            height: props.collapsed ? 0 : 'auto'
        };
        return _this;
    }

    _createClass(ToggleBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateToggle();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var hideChildrenHasChanged = prevState.hideChildren !== this.state.hideChildren;
            var collapsedHasChanged = prevProps.collapsed !== this.props.collapsed;
            if (!hideChildrenHasChanged && (this.state.shouldToggleOnUpdate || collapsedHasChanged)) {
                this.updateToggle(prevState);
            }
        }
    }, {
        key: 'getOpenHeight',
        value: function getOpenHeight() {
            var offset = (0, _get2.default)(this.toggleBoxRef.current, 'offsetHeight');
            return (0, _isUndefined2.default)(offset) ? 'auto' : offset + 'px';
        }
    }, {
        key: 'getCalculatedHeight',
        value: function getCalculatedHeight() {
            return this.props.collapsed ? 0 : this.getOpenHeight();
        }
    }, {
        key: 'shouldToggle',
        value: function shouldToggle() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

            var calculatedHeight = this.getCalculatedHeight();
            var heightHasChanged = state.height !== calculatedHeight;
            var should = !this.state.isToggling && heightHasChanged;
            return should;
        }
    }, {
        key: 'updateToggle',
        value: function updateToggle() {
            var _this2 = this;

            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

            if (this.shouldToggle(state)) {
                var calculatedHeight = this.getCalculatedHeight();
                if (calculatedHeight === 0 && state.height === 'auto') {
                    var height = this.getOpenHeight();
                    this.setState({
                        height: height,
                        hideChildren: false,
                        shouldToggleOnUpdate: true
                    }, function () {
                        _this2.updateToggle();
                    });
                } else {
                    this.startAnimation(calculatedHeight);
                }
            }
        }
    }, {
        key: 'getAnimationTime',
        value: function getAnimationTime() {
            return this.props.animationDurationSeconds * 1000;
        }
    }, {
        key: 'afterToggle',
        value: function afterToggle() {
            var _this3 = this;

            this.isTogglingTimer = setTimeout(function () {
                return _this3.animationIsComplete();
            }, this.getAnimationTime());
        }
    }, {
        key: 'startAnimation',
        value: function startAnimation(calculatedHeight) {
            var _this4 = this;

            this.setState({
                shouldToggleOnUpdate: false,
                isToggling: true,
                hideChildren: false,
                allowOverflow: false,
                height: calculatedHeight
            }, function () {
                return _this4.afterToggle();
            });
        }
    }, {
        key: 'animationIsComplete',
        value: function animationIsComplete() {
            var _this5 = this;

            this.setState({ isToggling: false }, function () {
                if (_this5.shouldToggle()) {
                    _this5.updateToggle();
                } else {
                    if (_this5.state.height === 0) {
                        _this5.setState({ hideChildren: true });
                    } else {
                        _this5.setState({
                            allowOverflow: true,
                            height: 'auto'
                        });
                    }
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                fadeEffect = _props.fadeEffect,
                unmountHiddenChildren = _props.unmountHiddenChildren,
                animationDurationSeconds = _props.animationDurationSeconds;
            var _state = this.state,
                height = _state.height,
                hideChildren = _state.hideChildren,
                allowOverflow = _state.allowOverflow;

            var overflow = allowOverflow ? 'visible' : 'hidden';
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('rcw-toggle-box-wrapper', className),
                    style: {
                        height: height,
                        opacity: fadeEffect && height === 0 ? 0 : 1,
                        transition: 'height ' + animationDurationSeconds + 's ease-out',
                        overflow: overflow
                    } },
                _react2.default.createElement(
                    'div',
                    { ref: this.toggleBoxRef,
                        className: (0, _classnames2.default)({ invisible: hideChildren }) },
                    (!unmountHiddenChildren || !hideChildren) && children
                )
            );
        }
    }]);

    return ToggleBox;
}(_react2.default.Component);

ToggleBox.propTypes = {
    animationDurationSeconds: _propTypes2.default.number,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    collapsed: _propTypes2.default.bool,
    fadeEffect: _propTypes2.default.bool,
    unmountHiddenChildren: _propTypes2.default.bool
};
ToggleBox.defaultProps = {
    animationDurationSeconds: 0.5,
    collapsed: false,
    fadeEffect: false,
    unmountHiddenChildren: true
};
exports.default = ToggleBox;
//# sourceMappingURL=index.js.map